import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
 interface AccessDeniedDialogProps {
   open: boolean;
   onClose: () => void;
   onSwitchOrg: () => void;
 }
 
 const AccessDeniedDialog: React.FC<AccessDeniedDialogProps> = ({ open, onClose, onSwitchOrg }) => {
   return (
     <Dialog open={open} onClose={onClose}>
      <DialogTitle>Access Denied</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Access denied. If you are a member of the organization, you may have been removed. Please check with the organization admin.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        <Button onClick={onSwitchOrg} autoFocus>
          Switch Organization
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AccessDeniedDialog;